/* @flow */
import { resignAdminship } from 'admin/actions/OrgRoleActions.js';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import * as React from 'react';
import Organization from 'entities/Organization';
import ToastActions from 'actions/ToastActions';

type Props = {
  school: Organization,
  onRequestHide?: Function,
};

class AdminResignModal extends React.Component<Props> {
  resignAsAdmin = () => {
    return resignAdminship(this.props.school.id, CurrentUser.getUserId()).then(
      () =>
        ToastActions.showSuccessToast(
          `You have been removed as administrator of ${this.props.school.name}`
        ),
      ToastActions.showDefaultErrorToast
    );
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="AdminResignModal"
        title={`Remove yourself as administrator of ${this.props.school.name}?`}
        subtext="Once you do, you won’t have access to your school’s staff list,
          staff messaging, and other features for verified administrators."
        actionButtonText="Remove myself as administrator"
        cancelButtonText="Cancel"
        className="AdminResignModal"
        preConfirmPromise={this.resignAsAdmin}
        actionButtonColor="lava"
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}
export default AdminResignModal;
